import { Modal } from "antd";
import styles from "./Spinner.module.scss";

interface SpinnerProps {
  message: string;
}


const Spinner = (props: SpinnerProps) => {
  return (
    <Modal className={styles['spinner-model']} closable={false} visible={true} footer={null}>
      <div className="text-center">
        {props.message}<div className={styles['loading']}>...</div>
      </div>
    </Modal>
  );
};

export default Spinner;
